import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FactorManagerIsPaid from './paid'
import FactorManagerIsUnPaid from './unpaid'

const useStyles = makeStyles((theme) => ({
    title: {
        backgroundColor: '#950000',
        borderRadius: '10px',
        color: '#fff',
        fontWeight: '700'
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    container: {
        backgroundColor: '#F3F3F3',
        margin: '-10px auto',
        padding: '20px',
        borderBottomRadius: '10px',
        width: '98%',
    },
    whitecontainer: {
        margin: '0px',
    },
    tabPanel: {
        backgroundColor: '#F3F3F3',
        borderRadius: '10px'
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px 10px 0px 0px",
        maxWidth: "170px",
        backgroundColor: "#F3F3F3",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#F3F3F3",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "170px",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#616161",
        border: "1px solid #D0D0D0",
        borderBottom: "none",
        width: "100%",
    },
    show: {
        display: "block",
    },
    hide: {
        display: "none",
    },
    whiteBox2: {
        background: "#fff",
        borderRadius: '20px',
        [theme.breakpoints.up('sm')]: {
            minHeight: '477px',
        }
    },
}));

const FactorManager = () => {

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [persian, setPersian] = useState(true);
    const [arabic, setArabic] = useState(false);
    const [show, setShow] = React.useState(true);

    const ToggleArabic = () => {
        setPersian(false);
        setArabic(true);
    };

    const TogglePersian = () => {
        setArabic(false);
        setPersian(true);
    };

    return (
        <Box evelotion={0} mt={1}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Box evelotion={0} textAlign="center" p={1} className={classes.title}>
                        مدیریت فاکتورها
                    </Box>
                </Grid>
            </Grid>
            <Grid container className={classes.container} spacing={1}>
                <Grid item xs={12}>
                    <Box evelotion={1} mt={-1} p={2} className={classes.whiteBox2}>

                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Box>
                                    <Button
                                        className={persian ? classes.btnActive : classes.btn}
                                        onClick={TogglePersian}>پرداخت شده</Button>
                                    <Button
                                        className={arabic ? classes.btnActive : classes.btn}
                                        onClick={ToggleArabic}>پرداخت نشده</Button>
                                </Box>
                                <Box
                                    className={persian ? classes.show : classes.hide}
                                    pt={3}
                                    pb={3}
                                    bgcolor="#F3F3F3"
                                    style={{ borderRadius: '15px 0px 15px 15px' }}>
                                    <FactorManagerIsPaid />
                                </Box>
                                <Box
                                    pt={3}
                                    pb={3}
                                    className={arabic ? classes.show : classes.hide}
                                    bgcolor="#F3F3F3"
                                    style={{ borderRadius: '15px 0px 15px 15px' }}>
                                    <FactorManagerIsUnPaid />

                                </Box>


                            </Grid>

                        </Grid>

                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FactorManager;
